import { defaultIfNoValue } from 'app/utils/styleUtils'
import React from 'react'
import styled from 'styled-components'

type Props = {
  className?: string

  paddingTop?: number
  paddingTopMobile?: number
  paddingBottom?: number
  paddingBottomMobile?: number
}

export const Base = ({
  children,
  className,

  paddingTop,
  paddingTopMobile,
  paddingBottom,
  paddingBottomMobile,
}: WithChildren<Props>): JSX.Element => {
  return (
    <Wrapper
      className={className}
      paddingTop={paddingTop}
      paddingTopMobile={paddingTopMobile}
      paddingBottom={paddingBottom}
      paddingBottomMobile={paddingBottomMobile}
    >
      {children}
    </Wrapper>
  )
}

type WrapperProps = Pick<
  Props,
  'paddingBottom' | 'paddingBottomMobile' | 'paddingTop' | 'paddingTopMobile'
>

const Wrapper = styled.div<WrapperProps>`
  padding-top: ${({ paddingTopMobile, paddingTop }) =>
    defaultIfNoValue(3, paddingTopMobile || paddingTop)}rem;
  padding-bottom: ${({ paddingBottomMobile, paddingBottom }) =>
    defaultIfNoValue(3, paddingBottomMobile || paddingBottom)}rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    padding-top: ${({ paddingTop }) => defaultIfNoValue(6, paddingTop)}rem;
    padding-bottom: ${({ paddingBottom }) =>
      defaultIfNoValue(6, paddingBottom)}rem;
  }
`
